import { Button, makeStyles } from '@material-ui/core'
import * as React from 'react'

const useStyles = makeStyles((theme) => {
  return {
    cardBody: {
      border: `1px solid ${theme.palette.neutrals[200]}`,
      padding: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
      backgroundColor: '#ffffff',
    },
    colorsContainer: {
      display: 'flex',
      gap: theme.spacing(1),
    },
    colorItem: {
      width: '48px',
      height: '48px',
    },
    actionsContainer: {
      display: 'flex',
      gap: theme.spacing(1),
      width: '100%',
    },
    w100: {
      width: '100%',
    },
    capitalize: {
      textTransform: 'capitalize',
    },
  }
})

const PaletteCard: React.FC<{
  name: string
  description?: string
  colors: string[]
  onSelect: () => void
  onEdit?: () => void
  canEdit?: boolean
  selected?: boolean
}> = ({ name, description, colors, onSelect, onEdit, canEdit, selected }) => {
  const classes = useStyles()

  return (
    <div className={classes.cardBody}>
      <div>
        <h3 className={`is-size-5 mb-2 ${classes.capitalize}`}>{name}</h3>
        {description && <p className='is-size-6'>{description}</p>}
      </div>
      <div className={classes.colorsContainer}>
        {colors.map((color) => (
          <div key={color} className={classes.colorItem} style={{ backgroundColor: color }} />
        ))}
      </div>
      <div className={classes.actionsContainer}>
        <Button
          variant='outlined'
          color={selected ? 'primary' : 'default'}
          className={`${classes.w100} selectable`}
          onClick={onSelect}
          disabled={selected}
        >
          {selected ? 'Selected' : 'Select'}
        </Button>
        {canEdit && (
          <Button variant='outlined' className={classes.w100} onClick={onEdit}>
            Edit
          </Button>
        )}
      </div>
    </div>
  )
}

export default PaletteCard
